<template>
  <el-dialog title="Selecionar Pasta" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" @open="open" width="35%">
    <el-form size="small" label-position="top">
      <el-form-item label="Formulário">
        <el-input v-model="formulario.nome" readonly/>
      </el-form-item>

      <el-form-item label="Diretórios">
        <el-select v-model="diretorio.id" placeholder="Diretórios" filterable clearable loading-text="Carregando...">
          <el-option v-for="item in diretorios" :key="item.id" :label="item.nome" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="selecionarDiretorio()" type="primary" round size="small" class="btn-box-shadow">Selecionar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from 'axios';
import { mapActions } from "vuex";

import URLS from '../../util/urls.js';


export default {
  props: {
    visibility: Boolean,
    aluguel: Object,
    venda: Object,
    imovel: Object,
    imovelAluguel: Object,
    formulario: Object
  },

  data() {
    return {
      diretorio: {
        id: undefined
      },
      diretorios: []
    };
  },

  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions('loginStore', [
      'relogar',
    ]),
    // ALUGUEL
    ...mapActions("alugueisContratosStore", ["selecionarDiretorioAluguel"]),
    ...mapActions("alugueisImoveisStore", ["selecionarDiretorioImovelAluguel"]),
    // VENDA
    ...mapActions("vendasContratosStore", ["selecionarDiretorioVenda"]),
    ...mapActions("vendasImoveisStore", ["selecionarDiretorioImovelVenda"]),

    open() {
      this.reset();
      this.recuperarDiretorios();
    },

    reset() {
      this.diretorio = {
        id: undefined,
      };
    },

    selecionarDiretorio() {
      this.showLoading();

      if (this.aluguel !== undefined && this.aluguel.id != 0) {
        this.diretorio["tipoFormularios"] = "ALUGUEL";

        this.formulario["diretorio"] = this.diretorio;
        this.formulario["idObjeto"] = this.aluguel.id;
        this.formulario["tipo"] = "ALUGUEL";

        this.selecionarDiretorioAluguel(this.formulario).then(resultado => {
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }

          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
      }

      if (this.imovelAluguel !== undefined && this.imovelAluguel.id != 0) {
        this.diretorio["tipoFormularios"] = "IMOVEL_ALUGUEL";

        this.formulario["diretorio"] = this.diretorio;
        this.formulario["idObjeto"] = this.imovelAluguel.id;
        this.formulario["tipo"] = "IMOVEL_ALUGUEL";

        this.selecionarDiretorioImovelAluguel(this.formulario).then(resultado => {
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }

          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
      }

      if (this.venda !== undefined && this.venda.id != 0) {
        this.diretorio["tipoFormularios"] = "VENDA";

        this.formulario["diretorio"] = this.diretorio;
        this.formulario["idObjeto"] = this.venda.id;
        this.formulario["tipo"] = "VENDA";

        this.selecionarDiretorioVenda(this.formulario).then(resultado => {
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }

          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
      }

      if (this.imovel !== undefined && this.imovel.id != 0) {
        this.diretorio["tipoFormularios"] = "IMOVEL_VENDA";

        this.formulario["diretorio"] = this.diretorio;
        this.formulario["idObjeto"] = this.imovel.id;
        this.formulario["tipo"] = "IMOVEL_VENDA";

        this.selecionarDiretorioImovelVenda(this.formulario).then(resultado => {
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }

          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
      }
    },

    getPayloadRecuperarDiretorios() {
      let tipoForm = ''

      if(this.venda !== undefined && this.venda.id != 0){
        tipoForm = 'VENDA'
      } else if (this.imovel !== undefined && this.imovel.id != 0) {
        tipoForm = 'IMOVEL_VENDA'
      } else if (this.aluguel !== undefined && this.aluguel.id != 0) {
        tipoForm = 'ALUGUEL'
      } else if (this.imovelAluguel !== undefined && this.imovelAluguel.id != 0) {
        tipoForm = 'IMOVEL_ALUGUEL'
      }

      let payload = {
        tipoFormularios: tipoForm,
      };

      return payload;
    },

    recuperarDiretorios() {
      const payload = this.getPayloadRecuperarDiretorios();
      this.showLoading();

      this.requestRecuperarDiretorios(payload).then(resultado => {
        switch (resultado.status) {
          case "SUCESSO":
            this.diretorios = resultado.lista;
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
      }).finally(() => {
        this.hideLoading();
      });
    },

    requestRecuperarDiretorios(payload) {
      return axios.post(URLS.FORMULARIOS_LISTAR_DIRETORIOS, payload).then(response => {
        switch(response.data.status) {
          case 'SESSAO_EXPIRADA':
            return this.relogar().then(authResponse => {
              if(authResponse.status === 'SUCESSO') {
                return this.requestRecuperarDiretorios(payload);
              }
            });

          default:
            return response.data;
        }    
      }).catch(error => {
        throw error;
      });
    },

    fechar() {
      this.$emit("close");
    }
  },
};
</script>

